import { Container, CssBaseline } from '@mui/material';
import ClientRates from './ClientRates';
import useGmdUserInfo from '../../../hooks/gmdUserInfo';

const ExchangeRates = () => {
  const { userInfo, canEditRates, canAddRates, canDeleteRates } =
    useGmdUserInfo();

  return (
    <Container component="main">
      <CssBaseline />
      {userInfo?.tenant && (
        <ClientRates
          tenantId={userInfo.tenant}
          allowEdits={canEditRates}
          showAddButton={canAddRates}
          allowDelete={canDeleteRates}
        />
      )}
    </Container>
  );
};

export default ExchangeRates;
